import React from "react"
import i18n from "@/i18n"
import { STATUS_CONFIRMED, STATUS_CANCELLED } from "@/constants/reservations"

const statusText = (status: string) => {
  if (status === STATUS_CONFIRMED) return i18n.t("app.public.reservation.confirmed")
  if (status === STATUS_CANCELLED) return i18n.t("app.public.reservation.cancelled")
  return i18n.t("app.public.reservation.pending")
}

const STYLES = {
  container: "bg-white px-5 py-5",
  statusText: "text-[18px] tracking-[-0.5px] text-[#171717]",
} as const

type Props = { status: string }

const ReservationStatusBanner: React.FC<Props> = ({ status }) => (
  <div className={STYLES.container}>
    <div className={STYLES.statusText}>{statusText(status)}</div>
  </div>
)

export default ReservationStatusBanner
